import { LANGUAGE_CODES } from '../../constants';

export const redirectToLoginPage = (lang = LANGUAGE_CODES.English) => {
  window.location.pathname = `/${lang}/login`;
};
